<template>
  <sharing-metadata
    :metadata-props="twitterMetadata"
    @update="$emit('update', $event)"
    @invalid="$emit('invalid')"
  >
    <template v-slot:header>Twitter metadata</template>
    <template v-slot:content="contentData">
      <el-form-item label="Text" prop="text">
        <el-input
          v-model="contentData.metadata.text"
          type="textarea"
          class="youtube-description__input"
          :rows="4"
        >
        </el-input>
      </el-form-item>
    </template>
  </sharing-metadata>
</template>

<script>
import SharingMetadata from "@/components/socials/share/metadata/SharingMetadata.vue";

// @group Socials
// Twitter sharing additional data (text) input
export default {
  name: "SharingTwitterMetadata",
  components: {
    SharingMetadata
  },
  props: {
    /** Twiter tweet text */
    text: {
      type: String,
      default: ""
    }
  },
  computed: {
    // @vuese
    // Twitter metadata properties
    twitterMetadata() {
      return [
        {
          id: "text",
          value: this.text,
          rules: [
            {
              max: 280,
              message: "Max tweet length is 280",
              trigger: "change"
            },
            {
              required: true,
              message: "Text is required",
              trigger: "change"
            }
          ]
        }
      ];
    }
  }
};
</script>
